<template>
    <!--手勢下滑關閉-->
    <PullDownClose @close="CloseBox(false)" class="date-card" noPull>
            <div class="fixed-pop-title">
                <div class="tabs">
                    <div v-if="storeInfo.orderDeliveryList.includes('1')" :class="{active: reservationType === '1'}" @click="reservationType='1'">自取</div>
                    <div v-if="storeInfo.orderDeliveryList.includes('2')" :class="{active: reservationType === '2'}" @click="reservationType='2'">外送</div>
                </div>
            </div>
            <div class="time-list">
                <div class="date-scroll">
                    <swiper ref="reservationDateSwiper" :options="dateSwiperOptions">
                        <swiper-slide class="date" v-for="(item, index) in showReservationDateTextList" :key="index" :dataIndex="item.dataIndex" :date="item.date">{{item.dateText}}</swiper-slide>
                    </swiper>
                </div>
                <div class="time-scroll">
                    <swiper ref="reservationPeriodSwiper" :options="periodSwiperOptions">
                        <swiper-slide class="time-range" v-for="(item, index) in showPeriodList" :dataIndex="item.dataIndex" :key="index">{{item.periodText}}</swiper-slide>
                    </swiper>
                </div>
            </div>
            <div class="text-center mb-4">
                <!--<el-button type="primary" round @click="CloseBox(false)" class="fixed-w-100">取消</el-button>-->
                <el-button round v-if="orderStatus" @click="CloseBox(true, false)" class="fixed-w-150">立即點餐</el-button>
                <el-button type="warning" round v-if="showReservationDateTextList.length > 0" @click="CloseBox(true, true)" class="fixed-w-150">確定時段</el-button>
            </div>
        </PullDownClose>
</template>

<script>
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    import * as mutationTypes from "@/store/mutationTypes";
    import * as constDefine from "@/store/constDefine";
    /*todo 輪播組件Swiper只支援vue3，要另外用外掛vue-awesome-swiper
       swiper4-6功能中文網 https://www.swiper.com.cn/api/autoplay/19.html*/
    import PullDownClose from "../../../components/PullDownClose";

    let vm = null

    export default {
        name: "PickTime",
        props: {
            value: {},
        },
        components: {
            Swiper,
            SwiperSlide,
            PullDownClose,
        },
        data() {
            return {
                //其他時間挑選
                isActive: this.value,
                dateSwiperOptions: {
                    grabCursor: true,
                    centeredSlides: true,
                    mousewheel: true,
                    slidesPerView: 3,
                    direction: 'vertical',
                    observeParents: true,
                    observe: true,
                    on: {
                      slideChange(){
                        if(vm.showReservationDateTextList.length > 0) {
                          vm.updatePeriodList()
                        }
                      },
                    }
                },
                periodSwiperOptions: {
                  grabCursor: true,
                  centeredSlides: true,
                  mousewheel: true,
                  slidesPerView: 3,
                  direction: 'vertical',
                },
                storeInfo: {
                  orderDeliveryList: [],
                },
                reservationType: '',
                reservationData:{},

                orderStatus: false,
                dateList: this.$store.state.pickTimeData.dateList,
                periodList: this.$store.state.pickTimeData.periodList,
                showPeriodList: [],
            }
        },
        computed: {
          showReservationDateTextList() {
            let date = new Date();
            let storeInfo = this.storeInfo;
            let isCanReservation = false;
            let isToDay = false;
            let reservationDay = 0

            if (this.reservationType === '1' && storeInfo.takeoutReservationStatus) {
              isCanReservation = true;
              let takeoutReservationTimeAry = storeInfo.takeoutReservationTime.split(":")
              let checkDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), takeoutReservationTimeAry[0], takeoutReservationTimeAry[1], "00")
              if(storeInfo.takeoutReservationType === 1) {
                isToDay = true;
              } else if (storeInfo.takeoutReservationType === 3) {
                isToDay = storeInfo.takeoutReservationToday;
                if(date > checkDate) {
                  reservationDay = storeInfo.takeoutReservationDay;
                }
              }
            } else if (this.reservationType === '2' && storeInfo.deliveryReservationStatus) {
              isCanReservation = true;
              let deliveryReservationTimeAry = storeInfo.deliveryReservationTime.split(":")
              let checkDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), deliveryReservationTimeAry[0], deliveryReservationTimeAry[1], "00")
              if(storeInfo.deliveryReservationType === 1) {
                isToDay = true;
              } else if (storeInfo.deliveryReservationType === 3) {
                isToDay = storeInfo.deliveryReservationToday;
                if(date > checkDate) {
                  reservationDay = storeInfo.deliveryReservationDay
                }
              }
            }

            if(isCanReservation) {
              let dataList = []
              let dateList = JSON.parse(JSON.stringify(this.dateList))
              dateList.forEach((item ,index) => {
                if((index === 0 && isToDay) ||
                    (index > 0 && index <= reservationDay)) {
                  dataList.push(item)
                }
              });

              return dataList;
            } else {
              return [];
            }
          }
        },
        created() {
          vm = this;
        },
        mounted() {
          this.storeInfo = this.$store.state.orderStoreInfo || {}
          this.reservationType = this.storeInfo.reservationType || ''
          this.orderStatus = this.storeInfo.orderStatus || false
        },
        methods: {
            //關閉
            CloseBox(result = false, isReservation = false){
                if(result) {
                  if(this.showReservationDateTextList.length === 0 && isReservation) {
                    this.$public.showNotify("未到店家開放預點時間", false);
                    return false
                  }

                  let reservationDateIndex = isReservation ? this.$refs.reservationDateSwiper.$swiper.slides[this.$refs.reservationDateSwiper.$swiper.activeIndex].getAttribute("dataIndex") : 0;
                  let reservationPeriodIndex = isReservation ? this.$refs.reservationPeriodSwiper.$swiper.slides[this.$refs.reservationPeriodSwiper.$swiper.activeIndex].getAttribute("dataIndex") : 0;
                  let reservationName = ""
                  if (this.reservationType === "1" ) {
                    reservationName = "自取"
                    if(isReservation && !this.storeInfo.isTakeoutReservation) {
                      this.$public.showNotify("不開放預點自取", false);
                      return false
                    }
                  } else if (this.reservationType === "2" ) {
                    reservationName = "外送"
                    if(isReservation && !this.storeInfo.isDeliveryReservation) {
                      this.$public.showNotify("不開放預點外送", false);
                      return false
                    }
                  }

                  let reservationTitle = isReservation ? reservationName + " " + this.dateList[reservationDateIndex].dateText + " " + this.periodList[reservationPeriodIndex].periodText.slice(0, 5) : "立即 " + reservationName
                  let reservationTime = isReservation ? this.dateList[reservationDateIndex].date + " " + this.periodList[reservationPeriodIndex].period : ''

                  this.isLoading = true;
                  this.$http.fetch`CheckStoreMenu${{
                    'storeId': this.storeInfo.id,
                    'reservationTime': reservationTime,
                    'posMenuId': this.storeInfo.posMenuId,
                  }}
                  ${json => {
                    if(json.status) {
                      if(json.data.menuData.id === 0) {
                        this.$public.showNotify("您選擇的時間查無菜單", false);
                      } else {
                        this.reservationData = {
                          reservationDateIndex: reservationDateIndex,
                          reservationPeriodIndex: reservationPeriodIndex,
                          reservationTime: reservationTime,
                          reservationType: this.reservationType,
                          reservationTitle: reservationTitle,
                          posMenuId: json.data.menuData.id,
                        }

                        if(json.data.isDiffPosMenuId) {
                          this.$store.commit(mutationTypes.setPublicCommDialogData,{
                            isShowDialog: true,
                            outerContent: json.message,
                            isCancel: true,
                            isResultEvent: true,
                            eventName: constDefine.changePosMenu,
                          });
                        } else {
                          this.$store.commit(mutationTypes.setOrderStoreInfo, this.reservationData);
                          this.isActive = false
                          this.$emit('result', {
                            isChangePosMenu: false,
                            isChangeRadioTake: true,
                            radioTake: this.reservationType,
                          });
                        }
                      }
                    } else {
                      this.$public.showNotify(json.message, false);
                    }

                    this.isLoading = false;

                  }}`;
                } else {
                  this.isActive = false
                  this.$emit('result', {
                    isChangePosMenu: false,
                    isChangeRadioTake: false,
                  });
                }
            },
            updatePeriodList() {
              let date = new Date();
              let year = date.getFullYear()
              let month = date.getMonth()
              let day = date.getDate()
              let toDay = new Date(year, month, day)
              let periodList = JSON.parse(JSON.stringify(this.periodList))

              let reservationDateIndex = this.$refs.reservationDateSwiper.$swiper.activeIndex || 0

              setTimeout(() => {
                let selectDate = this.$refs.reservationDateSwiper.$swiper.slides[reservationDateIndex].getAttribute("date")
                let selectDateAry = selectDate.split("-")
                let selectDay = new Date(selectDateAry[0], Number(selectDateAry[1]) - 1, selectDateAry[2])

                if(toDay >= selectDay) {
                  let dataList = []
                  periodList.forEach((item, index) => {
                    let periodAry = item.period.split(":")
                    let checkDate = new Date(year, month, day, periodAry[0], periodAry[1], periodAry[2])
                    if(checkDate > date) {
                      dataList.push(item)
                    }
                  })
                  this.showPeriodList = dataList
                } else {
                  this.showPeriodList = periodList.map((item, index) => {
                    return item
                  })
                }

                let toIndex = -1
                let reservationPeriodIndex = Number(this.storeInfo.reservationPeriodIndex)
                this.showPeriodList.some((item, index) => {
                  if(toIndex === -1) {
                    toIndex = index
                    return false
                  } else if (item.dataIndex === reservationPeriodIndex) {
                    toIndex = index
                    return true
                  }
                })

                setTimeout(() => {
                  this.$refs.reservationPeriodSwiper.$swiper.slideTo(toIndex)
                },100)

              },100)
            },
            reservationDateSwiperSlideTo() {
              let toIndex = -1
              let reservationDateIndex = Number(this.storeInfo.reservationDateIndex)
              this.showReservationDateTextList.some((item, index) => {
                  if(toIndex === -1) {
                    toIndex = index
                    return false
                  } else if (item.dataIndex === reservationDateIndex) {
                    toIndex = index
                    return true
                  } else if (item.dataIndex < reservationDateIndex) {
                    toIndex = index
                    return false
                  }
              })

              setTimeout( () => {
                if(typeof this.$refs.reservationDateSwiper !== "undefined") {
                  this.$refs.reservationDateSwiper.$swiper.slideTo(toIndex)
                  this.updatePeriodList()
                }
              },100)

            },
        },
        watch: {
            value() {
                this.isActive = this.value;
            },
            '$store.state.publicCommDialogData.isShowDialog': function() {
              let routerName = this.$route.name
              if(routerName === 'OrderList' || routerName === 'OrderCart') {
                if(!this.$store.state.publicCommDialogData.isShowDialog && this.$store.state.publicCommDialogData.isResultEvent && this.$store.state.publicCommDialogData.result) {
                  if(this.$store.state.publicCommDialogData.eventName === constDefine.changePosMenu) {

                    this.$sqlite.delete('delete from shopping_cart_meal_choiceList',[],function(resultSet){});
                    this.$sqlite.delete('delete from shopping_cart_meal_data',[],function(resultSet){});
                    this.$store.commit(mutationTypes.setOrderStoreInfo, this.reservationData);
                    this.isActive = false
                    this.$emit('result', {
                      isChangePosMenu: true,
                      isChangeRadioTake: true,
                      radioTake: this.reservationType,
                    });
                  }

                  this.$store.commit(mutationTypes.setPublicCommDialogData,{
                    isResultEvent: false,
                    eventName: "",
                  });
                }
              }
            },
            showReservationDateTextList: {
              handler:function () {
                if(this.showReservationDateTextList.length > 0) {
                  this.reservationDateSwiperSlideTo()
                } else {
                  this.showPeriodList = []
                }
              },
              deep:true,
              immediate:true,
            },
        },
    }
</script>

<style lang="less" scoped>
    .swiper-container{
        height: 100%;
    }
</style>
